"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = Spotify;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function Spotify(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", {
    version: "1.1",
    id: "_x30_6_-_INTERNET_KOPPELINGEN",
    xmlns: "http://www.w3.org/2000/svg",
    x: "0px",
    y: "0px",
    viewBox: "0 0 22 22"
  }, /*#__PURE__*/_react["default"].createElement("style", {
    dangerouslySetInnerHTML: {
      __html: ".spotify0{fill:#FFFFFF;}"
    }
  }), /*#__PURE__*/_react["default"].createElement("path", {
    className: "spotify0",
    d: "M9.9,2.1c1.6-0.2,3.2,0,4.6,0.7c1.7,0.7,3.2,2,4.1,3.5c0.8,1.3,1.3,2.8,1.3,4.3c0.1,1.7-0.3,3.4-1.2,4.9 c-0.9,1.5-2.1,2.7-3.7,3.5c-1.7,0.9-3.6,1.2-5.4,0.9c-1.6-0.2-3-0.9-4.3-1.8c-1.3-1-2.3-2.4-2.9-4c-0.6-1.8-0.7-3.7-0.2-5.5 c0.5-1.7,1.4-3.2,2.7-4.3C6.4,3,8.1,2.3,9.9,2.1z M8.4,6.8c-1,0.1-2,0.2-3,0.5C5,7.5,4.7,7.9,4.8,8.4c0.1,0.4,0.6,0.7,1,0.6 c1.3-0.4,2.7-0.5,4-0.5c1.3,0,2.6,0.2,3.8,0.5c0.9,0.2,1.9,0.6,2.7,1.1c0.3,0.2,0.6,0.2,0.9,0c0.3-0.2,0.5-0.5,0.4-0.8 c0-0.3-0.2-0.5-0.4-0.6c-0.6-0.4-1.3-0.7-2-0.9C13,6.9,10.7,6.7,8.4,6.8z M9.1,9.9c-1.1,0-2.1,0.2-3.2,0.5c-0.3,0.1-0.5,0.4-0.5,0.7 c0,0.3,0.2,0.6,0.5,0.7c0.2,0.1,0.4,0,0.7-0.1c1.3-0.3,2.6-0.4,3.9-0.3c1.7,0.1,3.3,0.6,4.8,1.5c0.3,0.2,0.8,0,1-0.3 c0.1-0.3,0-0.7-0.3-0.9C13.9,10.3,11.5,9.8,9.1,9.9z M8.6,12.8C7.8,12.9,7,13,6.2,13.2c-0.4,0.1-0.5,0.5-0.3,0.8 c0.1,0.2,0.4,0.3,0.7,0.2c0.9-0.2,1.7-0.3,2.6-0.4c1.6-0.1,3.3,0.2,4.8,1c0.2,0.1,0.3,0.2,0.5,0.3c0.3,0.1,0.6,0,0.7-0.3 c0.1-0.2,0-0.5-0.2-0.7C13.1,13,10.8,12.7,8.6,12.8z"
  }), /*#__PURE__*/_react["default"].createElement("g", null), /*#__PURE__*/_react["default"].createElement("g", null), /*#__PURE__*/_react["default"].createElement("g", null), /*#__PURE__*/_react["default"].createElement("g", null), /*#__PURE__*/_react["default"].createElement("g", null), /*#__PURE__*/_react["default"].createElement("g", null));
}